<template>
  <pt-save-sign-detail class="pt-save-sign-detail__withData" :id="id" :signId="signId" :data="notesDetail" @cancelSign="cancelSign"
  :cancelLoading="cancelLoading" :signDetail="signDetail" :loading="loading" @signNotesDetail="signNotesDetail"></pt-save-sign-detail>
</template>

<script>
import PtSaveSignDetail from './index'
export default {
  name: 'pt-save-sign-detail__withData',
  components: {
    'pt-save-sign-detail': PtSaveSignDetail
  },
  props: {
    id: {
      type: String
    },
    signId: {
      type: String
    }
  },
  data () {
    return {
      notesDetail: {},
      cancelLoading: false,
      signDetail: {},
      detailLoading: false,
      notesLoading: false
    }
  },
  computed: {
    loading () {
      return this.detailLoading || this.notesLoading
    }
  },
  methods: {
    cancelSign () {
      this.cancelLoading = true
      this.$store.dispatch('cancelSign', this.id).then(res => {
        this.cancelLoading = false
        this.$message.success('取消报名成功')
        this.signNotesDetail()
      }).catch(err => {
        this.cancelLoading = false
        this.$message.error(err || '取消报名失败')
      })
    },
    getSignDetail () {
      this.detailLoading = true
      this.$store.dispatch('getSignDetail', this.signId).then(res => {
        this.detailLoading = false
        this.signDetail = res
      }).catch(err => {
        this.detailLoading = false
        this.$message.error(err || '获取报名详情失败')
      })
    },
    signNotesDetail () {
      this.notesLoading = true
      this.$store.dispatch('signNotesDetail', this.id).then(res => {
        this.notesLoading = false
        this.notesDetail = res
      }).catch(err => {
        this.notesLoading = false
        this.$message.error(err || '获取报名记录详情失败')
      })
    }
  },
  created () {
    this.signNotesDetail()
    this.getSignDetail()
  }
}
</script>
